<template>
    <aside class="nav__modal">
        <HeaderMobile :isModal="true" @closeModal="$emit('toggleNav')" />

        <article class="nav__section">
            <h2>What resources are you looking for?</h2>
            <FormSearch @closeMobNav="$emit('closeMobNav')" />
        </article>

        <article class="nav__section">
            <h2>Menu</h2>
            <NavMain :isModal="true" @closeNav="$emit('toggleNav')" />
        </article>

        <footer class="nav__footer">
            <FooterContact />
            <FooterCopyright />
        </footer>
    </aside>
</template>

<script>
export default {
    created () {
        document.querySelector('body').style.overflow = 'hidden'
    },

    beforeDestroy () {
        document.querySelector('body').style.overflow = null
    }
}
</script>

